module.exports = __webpack_public_path__ + "static/media/justokEmoji.a382d7ef.svg";